// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "社会工作行政",
        "tec": "张梦琪",
        "week": "1-12周",
        "add": "教学楼D座324经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "王艳峰",
        "week": "13周",
        "add": "教学楼D座228经管"
      }
    ],
    [
      {
        "sub": "公共关系",
        "tec": "于瑶",
        "week": "1-8周",
        "add": "实训楼E座311东"
      },
      {
        "sub": "儿童和青少年社会工作",
        "tec": "赵勤",
        "week": "9-12周",
        "add": "教学楼D座227经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "王艳峰",
        "week": "13周",
        "add": "教学楼D座228经管"
      }
    ],
    {
      "sub": "能源电力工程与绿色低碳技术",
      "tec": "马仕海张翼",
      "week": "1-8周",
      "add": "教学楼D座226经管"
    },
    0,
    0
  ],
  "2": [
    [
      {
        "sub": "社会组织管理",
        "tec": "王星月",
        "week": "1-11周",
        "add": "教学楼D座314文法"
      },
      {
        "sub": "劳动与创造",
        "tec": "王艳峰",
        "week": "13周",
        "add": "教学楼D座228经管"
      }
    ],
    [
      {
        "sub": "社区工作",
        "tec": "王艳峰",
        "week": "1-12周",
        "add": "教学楼D座324经管"
      },
      {
        "sub": "劳动与创造",
        "tec": "王艳峰",
        "week": "13周",
        "add": "教学楼D座228经管"
      }
    ],
    {
      "sub": "家庭社会工作",
      "tec": "刘焕焕",
      "week": "1-12周",
      "add": "教学楼D座314文法"
    },
    {
      "sub": "国家安全教育",
      "tec": "李进",
      "week": "9-12周",
      "add": "教学楼A座321电力"
    },
    {
      "sub": "就业创业指导",
      "tec": "马彤兵",
      "week": "7-11周",
      "add": "教学楼D座226经管"
    }
  ],
  "3": [
    {
      "sub": "儿童和青少年社会工作",
      "tec": "赵勤",
      "week": "1-12周",
      "add": "教学楼D座228经管"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓王树平",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "公共关系",
        "tec": "于瑶",
        "week": "9-12周",
        "add": "实训楼E座311东"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "社区工作",
      "tec": "王艳峰",
      "week": "1-12周",
      "add": "教学楼D座324经管"
    },
    {
      "sub": "社会组织管理",
      "tec": "王星月",
      "week": "1,3,5,7,9周",
      "add": "教学楼D座325经管"
    },
    {
      "sub": "社会工作行政",
      "tec": "张梦琪",
      "week": "1-12周",
      "add": "教学楼D座223经管"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "公益慈善与志愿服务",
      "tec": "陈阳",
      "week": "1-12周",
      "add": "教学楼D座327经管"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "李芗霓王树平",
        "week": "1-8周",
        "add": "图书馆1楼党史+网络数字教育基地"
      },
      {
        "sub": "家庭社会工作",
        "tec": "刘焕焕",
        "week": "9-12周",
        "add": "教学楼D座314文法"
      }
    ],
    [
      {
        "sub": "公共关系",
        "tec": "于瑶",
        "week": "1-4周",
        "add": "实训楼E座311东"
      },
      {
        "sub": "国家安全教育",
        "tec": "李进",
        "week": "9-12周",
        "add": "教学楼D座417文法"
      }
    ],
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
